import { render, staticRenderFns } from "./spuList.vue?vue&type=template&id=faf37122&scoped=true&lang=html&"
import script from "./spuList.vue?vue&type=script&lang=js&"
export * from "./spuList.vue?vue&type=script&lang=js&"
import style0 from "./spuList.vue?vue&type=style&index=0&id=faf37122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf37122",
  null
  
)

export default component.exports